import {io} from "socket.io-client";

const API_URL = window.location.hostname.endsWith('forestarena.fr')
    ? 'https://api.forestarena.fr'
    : 'https://werewolfapi.maxime-blouin.fr';

export const socket = io(API_URL, {
    autoConnect: false
});
